import type { ItemStateType } from './itemState';
import type { DynamoItemType} from './itemTypes';
import { ItemType } from './itemTypes';
import type { ItemMetaData } from './fieldValue';
import { isObject } from '@mimir/primitive/type-guards/isObject';

export interface PersonDto {
  id: string;
  createdOn: string;
  itemType: DynamoItemType;
  name: string;
  description?: string;
  primaryImageId?: string;
  imageIds?: string[];
  nameHighlighted?: string;
  descriptionHighlighted?: string;
  itemState?: ItemStateType;
}

export const isInstanceOfPersonDto = (obj: unknown): obj is PersonDto => {
  if (!isObject(obj)) return false;
  return 'id' in obj && 'itemType' in obj && obj['itemType'] === ItemType.PERSON;
};

export interface PersonImageDto {
  id: string;
  title: string;
  itemType: 'image';
  itemState?: string;
  personId: string;
  thumbnail: string | null;
  transcodingState?: string;
  mediaType?: string;
  createdOn?: string;
  imageExistWithNoBackground?: boolean;
  createdBy?: string;
  originalFileName?: string;
  metadata?: ItemMetaData;
  ingestSourceKey?: string;
  itemDeletedBy?: string;
  purgeDate?: string;
  itemUndeletedBy?: string;
}

export type SimilarPersonsDto = {
  personId: string;
  imageId: string;
  similarity: number;
  personName: string;
  personThumbnailUrl: string;
}[];



export const isInstanceOfPersonImageDto = (obj: unknown): obj is PersonImageDto => {
  if (!isObject(obj)) return false;
  return 'id' in obj && 'itemType' in obj && obj['itemType'] === ItemType.IMAGE && 'personId' in obj;
};

export const isCollectionOfPersonImageDto = (obj: unknown): obj is PersonImageDto[] => {
  if(!Array.isArray(obj)) return false;
  if (obj.length > 0) {
    return isInstanceOfPersonImageDto(obj[0]);
  }
  return true;
};
